import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for TextBanner module:
 * variants:
 *  - colorWorld: fjordBlue | cherry | pineGreen | terracotta | malva | sunflower | custom
 */

// Maps colorWorlds to CTA variants for theme-independent contrast
export const CTA_VARIANT_MAP = {
    fjordBlue: {
        secondary: 'secondaryGhostOnMedia',
        text: 'textSecondaryGhostOnMedia'
    },
    cherry: {
        secondary: 'secondaryGhostOnMedia',
        text: 'textSecondaryGhostOnMedia'
    },
    pineGreen: {
        secondary: 'secondaryGhostOnMedia',
        text: 'textSecondaryGhostOnMedia'
    },
    terracotta: {
        secondary: 'secondaryGhostOnMedia',
        text: 'textSecondaryGhostOnMedia'
    },
    malva: {
        secondary: 'secondaryGhostOnMedia',
        text: 'textSecondaryGhostOnMedia'
    },
    sunflower: {
        secondary: 'secondaryGhost',
        text: 'textSecondaryGhost'
    },
    custom: {
        secondary: 'secondaryGhost',
        text: 'text'
    }
}

export default defineSlotRecipe({
    slots: ['root', 'contentContainer', 'copyWrapper', 'ctaWrapper'],
    base: {
        root: {
            borderRadius: 'xs',
            backgroundColor: 'background.section.strong',
            color: 'text.primary',
            paddingBlock: 'spacing-20',
            paddingInline: 'spacing-16'
        },
        contentContainer: {
            display: 'flex',
            flexDirection: {base: 'column', s: 'row'},
            alignItems: {base: 'flex-start', s: 'center'},
            gap: {base: 'spacing-12', s: 'spacing-16'}
        },
        copyWrapper: {
            flex: 1,
            textStyle: 'body.small',
            textAlign: 'left'
        },
        ctaWrapper: {
            flexShrink: 0,
            alignSelf: {base: 'flex-start', s: 'center'}
        }
    },
    variants: {
        colorWorld: {
            fjordBlue: {
                root: {
                    backgroundColor: 'secondary.fjordBlue',
                    color: 'text.on-media.primary'
                }
            },
            cherry: {
                root: {
                    backgroundColor: 'secondary.cherry',
                    color: 'text.on-media.primary'
                }
            },
            pineGreen: {
                root: {
                    backgroundColor: 'secondary.pineGreen',
                    color: 'text.on-media.primary'
                }
            },
            terracotta: {
                root: {
                    backgroundColor: 'secondary.terracotta',
                    color: 'text.on-media.primary'
                }
            },
            malva: {
                root: {
                    backgroundColor: 'secondary.malva',
                    color: 'text.on-media.primary'
                }
            },
            sunflower: {
                root: {
                    backgroundColor: 'secondary.sunflower',
                    color: 'text.primary'
                }
            },
            // Entirely controlled by CMS-specified colors via CSS custom properties.
            // The component injects --banner-bg and --banner-color.
            custom: {
                root: {
                    backgroundColor: 'var(--banner-bg)',
                    color: 'var(--banner-color)'
                },
                ctaWrapper: {
                    '& button, & a': {color: 'inherit'}
                }
            }
        }
    }
})
